import './logo.scss';

export function Logo() {
  return (
    <div className='mb-8 my-0 mx-auto pt-8 relative overflow-hidden '>
      <div className='max-w-[752px] w-full my-0 mx-auto flex justify-center'>
        <div className='bg-center bg-no-repeat bg-contain block text-inherit m-0 p-0 no-underline h-[58px] w-[200px] logo' />
      </div>
    </div>
  );
}
